module.exports = __webpack_public_path__ + "img/15.d05db403.webp";